import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { matchRoutes } from "react-router";

const isPositiveInteger = (val: unknown): boolean => /^[1-9]\d*$/.test(val?.toString() ?? "");

const getLocationParams = (url: string) => {
  const routes = [
    { path: "/:customerId/*" },
    { path: "/:customerId/admin/:sport/*" },
    { path: "/:customerId/admin/:sport/:organizationId/*" },
    { path: "/:customerId/admin/:sport/:organizationId/seasons/:seasonId/*" },
  ];

  const match = matchRoutes(routes, url);
  const params = match?.[0]?.params || {};

  return {
    customerId: isPositiveInteger(params.customerId) ? params.customerId : undefined,
    sport: params.sport || "",
    organizationId: params.organizationId || "",
    seasonId: params.seasonId || "",
  };
};

export const useGetLocationParams = () => {
  const location = useLocation();
  return useMemo(() => getLocationParams(location.pathname), [location.pathname]);
}
